/** @module Classes */ /** typedoc */

import { Price } from './../Price';

export class ReleaseBalance extends Price {
    public totalAmountReceived: number = null;
}
